module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABGdBTUEAALGOfPtRkwAAACBjSFJNAACHDwAAjA8AAP1SAACBQAAAfXkAAOmLAAA85QAAGcxzPIV3AAAACXBIWXMAAAsSAAALEgHS3X78AAABE0lEQVRYR+2Vyw3DIAyG0zU7TUfJoYN0pZ5zoLEtwAQ/gB5QJCJZ5OHEn//Y5hFC2KYeADDTpgZH9WdmvwCWAvdX4BxgB9g/nTTUhvv+fmLwEMjOc7g3AtIMELNlK8xwbgjSq4gLkLLdIFMaXRQ4nldrF4QLQFldg5gAANcMYQKw7GloH1+0qEC85itTqakuTACefRmEFJAACDD9KhdCBTCK7Vp83rVZnA6AWmhWEWrPxLpoBIjtJhWj9Ez1r4ZWA8D5sdeHzG6/3KKqfz01vRrAwKn6XQiCVfxHfoH2wWIClkUoAqC/uGeoCsAMSHMgS4ptZRl2j+Iv7RXuJMzDqG3D6fV3AUZ2uJ53FsBSYCkwXYEflneEbc56xLsAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/res/cblue_4.png
// module id = ZuFh
// module chunks = 1